import { useTranslation } from "react-i18next";

import { FilterHeader } from "@shared/table/headers/FilterHeader";

const channels = ["live", "beta", "nightly", "none"] as const;

type Props = {
    value: string[];
    onChange: (value: string[]) => void;
};

export const OtaChannelHeader = ({ value, onChange }: Props) => {
    const { t } = useTranslation(["common", "modals"]);
    const options = channels.map((channel) => ({ key: channel, label: t(`common:label.${channel}`) }));

    return (
        <FilterHeader
            title={t("modals:filterDialog.variants.channel")}
            sortDisabled
            options={options}
            initialValues={Object.fromEntries(options.map((o) => [o.key, value.includes(o.key)]))}
            onSubmit={(values) => {
                onChange(Object.keys(values).filter((k) => values[k]));
            }}
        />
    );
};
